class FloatingLabelHandler {
  constructor(inputSelector, labelContainerSelector) {
    this.inputs = document.querySelectorAll(inputSelector);
    this.labelContainers = document.querySelectorAll(labelContainerSelector);
    this.initialize();
  }

  initialize() {
    this.inputs.forEach((input, index) => {
      if (index < this.labelContainers.length) {
        const container = this.labelContainers[index];

        // Check for autofill on load
        this.checkAutofill(input, container);

        input.addEventListener("focus", () => this.activateLabel(container));
        input.addEventListener("blur", () => this.activateLabel(container));
        input.addEventListener("input", () => this.activateLabel(container));
        input.addEventListener("keyup", () => this.activateLabel(container));
        input.addEventListener("click", () => this.activateLabel(container));
      }
    });

    // Check autofill after a short delay (for browsers that autofill after load)
    setTimeout(() => {
      this.inputs.forEach((input, index) => {
        if (index < this.labelContainers.length) {
          const container = this.labelContainers[index];
          this.checkAutofill(input, container);
        }
      });
    }, 500);
    
    document.addEventListener("click", this.handleDocumentClick.bind(this));
  }
  
  checkAutofill(input, container) {
    // Check for state.isAutofilled or fallback to value
    if ((input.state && input.state.isAutofilled) || input.matches(":-webkit-autofill") || input.value.trim() !== "") {
      container.classList.add("active");
    }
  }
  
  activateLabel(container) {
    container.classList.add("active");
  }
  
  handleDocumentClick(event) {
    this.inputs.forEach((input, index) => {
      if (index < this.labelContainers.length) {
        const container = this.labelContainers[index];
        
        if (!input.contains(event.target) && document.activeElement !== input) {
          if (input.value.trim() === "") {
            container.classList.remove("active");
          }
        }
      }
    });
  }
}

window.addEventListener("load", function () {
  setTimeout(() => {
    new FloatingLabelHandler(".location-input", ".input-lagend-main");
  }, 500);
});